import { Box, useMediaQuery, useTheme } from "@mui/material";
import MainAppBar from "../global/MainAppBar";
import BottomNavigator from "../ui/BottomNavigator";
// import Footer from "../ui/Footer";
import { useAuth } from "../../hooks/useAuth";
import DesktopLayout from "./DesktopLayout";
import "./Layout.css";
import SharedLayout from "./SharedLayout";

const Layout = ({ hideAppbar = false, ...props }: any) => {
  const { isAuthenticated } = useAuth();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));


  if (isDesktop) {
    return <DesktopLayout hideAppbar={hideAppbar}>{props.children}</DesktopLayout>;
  }

  return (
    <SharedLayout>
      <Box className="app-container">
        {hideAppbar ? null : <MainAppBar />}
        <Box>
          {props.children}
        </Box>
        {isAuthenticated && <BottomNavigator />}
        {/* <Footer /> */}
      </Box>
    </SharedLayout>
  );
};

export default Layout;
